"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function AboutUs() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const imageContainerRef = useRef<HTMLDivElement>(null);
  const [parallaxOffset, setParallaxOffset] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (!imageContainerRef.current) return;
      const rect = imageContainerRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const scrollProgress = (windowHeight - rect.top) / (windowHeight + rect.height);
      if (scrollProgress >= 0 && scrollProgress <= 1) {
        setParallaxOffset(scrollProgress * 30 - 15);
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="about-us" className="bg-background text-foreground py-16 md:py-24">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
          {}
          <div ref={textRef} className={`space-y-6 transition-all duration-[150ms] ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <h2 className="font-display text-[36px] md:text-[48px] font-bold leading-[1.2] text-foreground">
              About Us
            </h2>
            <div className="space-y-4 text-muted-foreground text-base md:text-lg leading-relaxed">
              <p>
                Mark Johnston Motors Ltd. is a trusted automotive repair shop
                serving the Wicklow area with three convenient locations across
                Rathnew, Blainroe, and Wicklow Town.
              </p>
              <p>
                With experienced technicians and a commitment to quality, we
                provide comprehensive vehicle care for all makes of cars and
                light commercial vehicles. From full diagnostics and NCT
                repairs to tyre services and routine maintenance, we're
                dedicated to keeping your vehicle running smoothly.
              </p>
              <p>
                Our team combines technical expertise with friendly local
                service, ensuring reliable maintenance and repairs that drivers
                throughout the Wicklow area can trust.
              </p>
            </div>
          </div>

          {}
          <div ref={imageContainerRef} className="relative overflow-hidden rounded-md shadow-medium h-[400px] md:h-[500px]">
            <div className="absolute inset-0 transition-transform duration-100 ease-out" style={{
            transform: `translateY(${parallaxOffset}px)`
          }}>
              <img src="https://adequate-yeti.10web.cloud/wp-content/uploads/2026/02/Untitled-design-7.png" alt="Mark Johnston Motors workshop team" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}